import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

/**
 * ProtectedRoute Component
 * 
 * Simple authentication check using localStorage token.
 * Avoids React Query complexity that causes infinite loops.
 */
export const ProtectedRoute: React.FC = () => {
  // Simple token check from localStorage
  const [hasToken, setHasToken] = React.useState(() => {
    try {
      const storedState = localStorage.getItem('bgai-auth-storage')
      if (storedState) {
        const parsed = JSON.parse(storedState)
        return !!parsed.state?.token
      }
    } catch {
      return false
    }
    return false
  })

  // Listen for storage changes (logout from other tabs) and poll for changes
  React.useEffect(() => {
    const checkToken = () => {
      try {
        const storedState = localStorage.getItem('bgai-auth-storage')
        if (storedState) {
          const parsed = JSON.parse(storedState)
          const newHasToken = !!parsed.state?.token
          setHasToken(newHasToken)
        } else {
          setHasToken(false)
        }
      } catch {
        setHasToken(false)
      }
    }

    const handleStorageChange = () => {
      checkToken()
    }

    // Check immediately
    checkToken()

    // Listen for storage events
    window.addEventListener('storage', handleStorageChange)
    
    // Poll every 500ms to catch rapid changes
    const interval = setInterval(checkToken, 500)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [])

  // Redirect to login if no token
  if (!hasToken) {
    return <Navigate to="/auth/login" replace />
  }

  // Render child routes if authenticated
  return <Outlet />
}